<template>
    <div  class="div4 cutbox">
        <div class="text1" data-id="主标题1">
            <span data-range="3,4">{{pre(info.titles[0])}}</span>
            <em></em>
            <span data-range="3,4">{{end(info.titles[0])}}</span>
        </div>
        <div class="text2" data-id="公司" data-range="8,28">{{info.company}}</div>
        <div class="text3"><img :src="info.image" alt=""></div>
        <div class="text4" data-id="长特点1" data-range="6,14">{{info.specialty[0]}}</div>
    </div>
</template>
<script>
export default {
  name: 'TUWEN004',
  props: {
    info: Object
  },
  methods: {
      pre(str) {
          return str.substr(0, str.length / 2);
      },
      end(str) {
          return str.substr(str.length / 2);
      }
  }
}
</script>
